(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-age-gate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('age-gate-rf')) {
    class RareFindAgeGate extends HTMLElement {
      #controller = new AbortController();
      #dialog;
      #confirmButton;
      #storageKey = 'rf_age_ack_v2';
      #legacyStorageKey = 'rf_age_ok';
      #cookieKey = 'rf_age_ack_v2';
      #version = 2;

      connectedCallback() {
        this.#dialog = this.querySelector('dialog');
        this.#confirmButton = this.querySelector('[data-age-confirm]');

        if (!this.#dialog || !this.#confirmButton || this.dataset.designMode === 'true') return;
        if (this.#hasCurrentAcknowledgement()) return;

        this.#dialog.addEventListener('cancel', this.#preventDismissal, { signal: this.#controller.signal });
        this.#dialog.addEventListener('click', this.#preventBackdropDismissal, { signal: this.#controller.signal });
        this.#dialog.addEventListener('keydown', this.#containFocus, { signal: this.#controller.signal });
        this.#confirmButton.addEventListener('click', this.#acknowledge, { signal: this.#controller.signal });
        window.addEventListener('pageshow', this.#handlePageShow, { signal: this.#controller.signal });

        this.#open();
      }

      disconnectedCallback() {
        this.#controller.abort();
        document.documentElement.classList.remove('rf-age-gate-open');
      }

      #retentionMilliseconds = () => {
        const days = Number.parseInt(this.dataset.retentionDays || '30', 10);
        const boundedDays = Number.isFinite(days) ? Math.min(Math.max(days, 1), 365) : 30;
        return boundedDays * 24 * 60 * 60 * 1000;
      };

      #parseAcknowledgement = (value) => {
        if (!value) return false;

        try {
          const acknowledgement = JSON.parse(value);
          return acknowledgement.version === this.#version && Number(acknowledgement.expiresAt) > Date.now();
        } catch (error) {
          return false;
        }
      };

      #readStorage = (storageName) => {
        try {
          return window[storageName].getItem(this.#storageKey);
        } catch (error) {
          return null;
        }
      };

      #readCookie = () => {
        const prefix = `${this.#cookieKey}=`;
        const cookie = document.cookie.split('; ').find((item) => item.startsWith(prefix));
        if (!cookie) return null;

        try {
          return decodeURIComponent(cookie.slice(prefix.length));
        } catch (error) {
          return null;
        }
      };

      #migrateLegacyAcknowledgement = () => {
        let legacyValue = null;

        try {
          legacyValue = window.localStorage.getItem(this.#legacyStorageKey);
          window.localStorage.removeItem(this.#legacyStorageKey);
        } catch (error) {
          legacyValue = null;
        }

        if (legacyValue !== '1') return false;
        this.#storeAcknowledgement();
        return true;
      };

      #hasCurrentAcknowledgement = () => {
        const values = [
          this.#readStorage('localStorage'),
          this.#readStorage('sessionStorage'),
          this.#readCookie(),
        ];

        if (values.some((value) => this.#parseAcknowledgement(value))) return true;
        return this.#migrateLegacyAcknowledgement();
      };

      #storeAcknowledgement = () => {
        const expiresAt = Date.now() + this.#retentionMilliseconds();
        const value = JSON.stringify({ version: this.#version, acknowledgedAt: Date.now(), expiresAt });
        let persisted = false;

        try {
          window.localStorage.setItem(this.#storageKey, value);
          persisted = true;
        } catch (error) {
          persisted = false;
        }

        if (!persisted) {
          try {
            window.sessionStorage.setItem(this.#storageKey, value);
            persisted = true;
          } catch (error) {
            persisted = false;
          }
        }

        if (!persisted) {
          const maxAge = Math.floor(this.#retentionMilliseconds() / 1000);
          document.cookie = `${this.#cookieKey}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
        }
      };

      #open = () => {
        document.documentElement.classList.add('rf-age-gate-open');

        if (this.#dialog.open) {
          // Already opened by the inline script after the markup.
        } else if (typeof this.#dialog.showModal === 'function') {
          this.#dialog.showModal();
        } else {
          this.#dialog.setAttribute('open', '');
        }

        // Focus the title (not the button) so no focus ring paints on load;
        // keyboard users land on the question and Tab to the actions.
        const title = this.querySelector('#RfAgeGateTitle');
        window.requestAnimationFrame(() => (title || this.#confirmButton).focus({ preventScroll: true }));
      };

      #close = () => {
        if (typeof this.#dialog.close === 'function') {
          this.#dialog.close();
        } else {
          this.#dialog.removeAttribute('open');
        }

        document.documentElement.classList.remove('rf-age-gate-open');
        const banner = document.querySelector('#shopify-pc__banner');
        const bannerButton = banner && banner.offsetParent !== null ? banner.querySelector('button') : null;
        (bannerButton || document.getElementById('MainContent'))?.focus({ preventScroll: true });
      };

      #acknowledge = () => {
        this.#storeAcknowledgement();
        this.#close();
      };

      #preventDismissal = (event) => {
        event.preventDefault();
        this.#confirmButton.focus();
      };

      #preventBackdropDismissal = (event) => {
        if (event.target === this.#dialog) this.#confirmButton.focus();
      };

      #containFocus = (event) => {
        if (event.key !== 'Tab') return;

        const focusable = [...this.#dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      #handlePageShow = () => {
        if (this.#hasCurrentAcknowledgement()) {
          if (this.#dialog.open) this.#close();
          return;
        }

        if (!this.#dialog.open) this.#open();
      };
    }

    customElements.define('age-gate-rf', RareFindAgeGate);
  }
  } catch(e) { console.error(e); }
})();

})();
